import { DATE_FORM_FORMAT } from '@/constants/date'
import moment from 'moment'
export const defaultFilters = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    groupBy: 'offer',
    secondGroupBy: 'date',
    dateFrom: moment().format(DATE_FORM_FORMAT),
    dateTo: moment().format(DATE_FORM_FORMAT),
    secondDateTo: moment().format(DATE_FORM_FORMAT),
    firstDeposit: null,
    advertisers: '',
    partners: '',
    offers: '',
    countries: '',
    paymentModels: '',

    offerCategories: '',
    products: '',
    subId: '',
    segment: '',
    landings: '',
    offerTags: '',
    partnerTags: '',
    trafficSources: '',
    mediaId: '',
    siteId: '',
    promocode: '',
    multigeoBreakdown: 'off',
    partnerGroups: null,
    clickId: '',
    streams: '',
  },
  sortBy: [],
  sortDesc: [],
  sortBy1: [],
  sortDesc1: [],
  sortBy2: [],
  sortDesc2: [],
  clientOptions: {
    filterPanelExpanded: false,
  },
})
